import * as yup from 'yup'
import {
  NUMERIC_FIELD_MESSAGE,
  REQUIRED_FIELD_MESSAGE,
  REQUIRED_MATERIAL_MESSAGE,
  strMaxLenMessage,
  WARRANTY_MONTHS_ERROR_MESSAGE,
} from '_/utils/form-validations'

function stripEmptyString(schema) {
  return schema.transform((value, original) => (original === '' ? undefined : value))
}

const materialSchema = yup.lazy(obj => {
  // if description is empty, all fields are not required
  if (!obj?.description) {
    return yup.object({
      description: stripEmptyString(yup.string().notRequired()),
      total: stripEmptyString(yup.number().notRequired()),
      quantity: stripEmptyString(yup.number().notRequired()),
      unitPrice: stripEmptyString(yup.number().notRequired()),
    })
  }

  // if description is not empty, all fields are required
  return yup.object({
    description: stripEmptyString(
      yup
        .string()
        .required(REQUIRED_MATERIAL_MESSAGE)
        .test('not-labor', 'A mão de obra agora é lançada nos campos ao lado.', value => {
          const description = value?.trim()?.toLowerCase()
          return !description.includes('mao de obra') && !description.includes('mão de obra')
        })
    ),
    total: stripEmptyString(yup.number().required(REQUIRED_MATERIAL_MESSAGE)),
    quantity: stripEmptyString(yup.number().required(REQUIRED_MATERIAL_MESSAGE)),
    unitPrice: stripEmptyString(yup.number().required(REQUIRED_MATERIAL_MESSAGE)),
  })
})

export const addProblemSchema = yup.object().shape({
  problem: yup.string().required(REQUIRED_FIELD_MESSAGE).trim(),

  showCompartment: yup.boolean(),
  compartment: yup
    .mixed()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .test('compartment-required', REQUIRED_FIELD_MESSAGE, function compartmentRequiredTest(value) {
      const { showCompartment } = this.parent
      if (showCompartment) {
        if (!value || typeof value !== 'object' || !value.label || !value.label.trim()) {
          return this.createError({ message: REQUIRED_FIELD_MESSAGE })
        }
        if (value.label.length > 30) {
          return this.createError({ message: strMaxLenMessage(30) })
        }
      }
      return true
    }),

  warrantyMonths: yup
    .number()
    .typeError(NUMERIC_FIELD_MESSAGE)
    .required(REQUIRED_FIELD_MESSAGE)
    .min(0, WARRANTY_MONTHS_ERROR_MESSAGE)
    .max(12, WARRANTY_MONTHS_ERROR_MESSAGE),
  isServiceMandatory: yup.boolean().required(REQUIRED_FIELD_MESSAGE),
  problemDescription: yup
    .string()
    .required(REQUIRED_FIELD_MESSAGE)
    .max(5000, strMaxLenMessage(5000)),
  serviceDescription: yup
    .string()
    .required(REQUIRED_FIELD_MESSAGE)
    .max(5000, strMaxLenMessage(5000)),
  laborValue: yup.number().nullable().notRequired().typeError(NUMERIC_FIELD_MESSAGE),
  numberOfProfessionals: yup
    .number()
    .min(0, NUMERIC_FIELD_MESSAGE)
    .nullable()
    .notRequired()
    .typeError(NUMERIC_FIELD_MESSAGE),
  laborTimeHours: yup.number().nullable().notRequired().typeError(NUMERIC_FIELD_MESSAGE),
  materials: yup.array().of(materialSchema),
  problemMedia: yup.mixed().nullable().notRequired(),
})

export const budgetFormSchema = (extendedWarranty = false) =>
  yup.object().shape({
    visitHappenedTemp: yup.boolean(REQUIRED_FIELD_MESSAGE).required(REQUIRED_FIELD_MESSAGE),
    additionalInfo: yup.string().max(5000, strMaxLenMessage(5000)),
    confidentialInfo: yup.string().max(5000, strMaxLenMessage(5000)),
    executionDue: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    additionalWarrantyMonths: extendedWarranty
      ? yup.number().min(0).required(REQUIRED_FIELD_MESSAGE).typeError(NUMERIC_FIELD_MESSAGE)
      : yup.number().nullable().notRequired(),
  })
